import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import PropTypes from 'prop-types';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '351px',
  // height: '180px',
  minHeight: '180px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: '48px 24px 24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
};

function AlertModal({
  open,
  setOpen,
  title = null,
  content = null,
  confirmLabel = '확인',
  onConfirm,
}) {
  return (
    <Modal
      open={open}
      onClose={() => setOpen(null)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        {title !== null && (
          <div className="flex flex-col justify-center items-center break-keep">
            {/* {title} */}
            {title?.split('\n')?.map(str => {
              return <div key={str}>{str}</div>;
            })}
          </div>
        )}
        <div className="w-full flex my-[10px] flex-col items-center justify-center text-[14px] font-[400] break-keep">
          {content?.split('\n')?.map(str => {
            return <div key={str}>{str}</div>;
          })}
        </div>
        <div className="flex w-full items-center justify-center gap-2">
          <Button
            variant="contained"
            onClick={() => {
              setOpen(null);
              onConfirm();
            }}
            sx={{ width: '113px' }}
          >
            {confirmLabel}
          </Button>
        </div>
      </Box>
    </Modal>
  );
}

AlertModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  content: PropTypes.string,
  confirmLabel: PropTypes.string,
  onConfirm: PropTypes.func.isRequired,
};

export default AlertModal;
